import { Request } from '@/classes/Request.ts'

export const assignFee = async (
  districtId: number,
  studentAccountId: number,
  menuItemId: number
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/add_other_fee/${districtId}`, {
        student_account_id: studentAccountId,
        menu_item_id: menuItemId
      })
      .then(() => {
        resolve()
      })
      .catch(err => {
        reject(err.responseJSON.failure_reason)
      })
  })
}
